
  import { defineComponent, ref } from 'vue';

  var vars = require('@/components/Base/base.scss');
  export default defineComponent({
    name: 'BasePopup',
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
    },
    setup(prop, { emit }) {
      const primaryColor = ref(vars['primary-color']);
      function close() {
        emit('update:modelValue', false);
      }
      return {
        close,
        primaryColor,
      };
    },
  });
